import {Component, Input, OnInit} from '@angular/core';
import {DbActiveModal} from "../../../modules/modal/modal-ref";
import {LottieComponent} from "ngx-lottie";
import {LowerCaseSpecificWordsPipe} from "../../../shared/pipes/lowerCaseSpecificWords.pipe";


@Component({
    selector: 'db-success-mobile-dialog',
    templateUrl: './success-mobile-dialog.component.html',
    styleUrls: ['./success-mobile-dialog.component.scss'],
    imports: [
        LottieComponent,
        LowerCaseSpecificWordsPipe
    ]
})
export class SuccessMobileDialogComponent implements OnInit {

  @Input() header: string;
  @Input() message: string;
  @Input() buttonText: string;

  lottieConfig: any;
  constructor(
    private readonly _activateModal: DbActiveModal,
  ) {
  }

  ngOnInit() {
    this.lottieConfig = {
      path: 'assets/images/lotties/success-lottie.json',
      renderer: 'svg',
      autoplay: true,
      loop: true
    };
    this._activateModal.hideCloseBtn(true);
  }

  public close() {
    this._activateModal.close();
  }
}
